//@flow
import React, {useState} from 'react';
import {useMsgs} from "../lib/Language";
import {Breadcrumb, Card} from "react-bootstrap";
import {BreadcrumbItem, PageHeader} from "../lib/Components";
import DesktopScreen from "./DesktopScreen";
import InvoiceMonitoringDesktopScreen from "./InvoiceMonitoringDesktopScreen";
import {InvoicesFilter, InvoicesList} from "../lib/InvoiceMonitoringComponents";
import {emptyQuery} from "../lib/Filter";
import {useDelayed, useHistoryState} from "../lib/Hooks";
import {ImportInvoicesDialog} from "../lib/InvoiceImport";
import {store} from "../application";
import {Redirect} from "react-router-dom";

const InvoiceMonitoringInvoicesScreen = () => {
    const msgs=useMsgs();
    // const [ filter, setFilter ] = useState(() => emptyQuery());
    const [ filter, setFilter ] = useHistoryState("filter", () => emptyQuery());
    const [ dFilter, setDFilter ] = useDelayed(filter, setFilter);
    if(!store.invoiceMonitoring || !store.invoiceMonitoring.read) return <Redirect to="/" push={false}/>

    return <>
        <Breadcrumb>
            <BreadcrumbItem to={DesktopScreen.url}>{msgs.gui.titleSummary}</BreadcrumbItem>
            <BreadcrumbItem to={InvoiceMonitoringDesktopScreen.link()}>{msgs.gui.menuInvoiceMonitoringDesktop}</BreadcrumbItem>
            <BreadcrumbItem active>{msgs.gui.menuInvoiceMonitoringInvoices}</BreadcrumbItem>
        </Breadcrumb>
        <PageHeader title={msgs.gui.menuInvoiceMonitoringInvoices}/>
        <Card className="mb-5">
            <Card.Body>
                <InvoicesFilter value={dFilter} onChange={setDFilter}/>
            </Card.Body>
        </Card>
        <InvoicesList customFilters={filter} historyState="table"/>
    </>;
}

InvoiceMonitoringInvoicesScreen.url="/im/invoices";
InvoiceMonitoringInvoicesScreen.link = () => InvoiceMonitoringInvoicesScreen.url;
export default InvoiceMonitoringInvoicesScreen;

export const InvoiceMonitoringImportDialog = () => {
    return <ImportInvoicesDialog/>;
}
InvoiceMonitoringImportDialog.url="/im/import";
InvoiceMonitoringImportDialog.link = () => InvoiceMonitoringImportDialog.url;